var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sellsy-ai-dialog", style: _vm.loaderPosition },
    [
      _c("div", { staticClass: "sellsy-ai-dialog__description" }, [
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "sellsy-ai-dialog__loading" },
              [
                _c("SellsyAILoader"),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-small-semibold" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.translate.write_content) +
                        "\n            "
                    )
                  ]
                )
              ],
              1
            )
          : _vm.quotaAILimitReached
          ? _c("div", { staticClass: "sellsy-ai-dialog__limit" }, [
              _c("img", {
                staticClass: "ai-icon",
                attrs: {
                  src: "/ressources/logged/img/icon/svg/ai-warning.svg",
                  alt: "ai icon"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-small-regular" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.translate.limit_quota) +
                      "\n            "
                  )
                ]
              )
            ])
          : _c(
              "div",
              { staticClass: "sellsy-ai-dialog__loaded" },
              [
                _c(
                  "div",
                  { staticClass: "sellsy-ai-dialog__message" },
                  [
                    _c("CompassIcon", {
                      attrs: {
                        icon: "ai-icon-write",
                        type: "secondary",
                        size: "small"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "typographies-paragraph-small-regular" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.translate.content_generated) +
                            "\n                "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("FeedbackPopover", {
                  attrs: { tags: _vm.tags, forceClose: _vm.forceCloseFeedback },
                  on: {
                    visibleChange: function($event) {
                      _vm.feedbackIsVisible = $event
                    },
                    tagSelected: _vm.handleTagSelect,
                    saveFeedback: _vm.saveFeedback,
                    reaction: _vm.handleReaction,
                    keypress: function($event) {
                      _vm.messageFeedback = $event
                    }
                  }
                })
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sellsy-ai-dialog__actions" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                placement: "bottom-end",
                disabled: !_vm.quotaAILimitReached
              },
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm.translate.limit_quota_tooltip))
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c("ButtonAI", {
                attrs: {
                  label: _vm.translate.regenerate,
                  type: "tertiary",
                  size: "small",
                  leftIcon: "sync",
                  disabled: _vm.disableRegenerate
                },
                on: { click: _vm.handleRegenerate }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              label: _vm.translate.cancel,
              type: "secondary",
              size: "small",
              "data-bot": "ai__dialog--cancel"
            },
            on: { click: _vm.handleCancel }
          }),
          _vm._v(" "),
          _c("ButtonAI", {
            attrs: {
              label: _vm.translate.validate,
              size: "small",
              disabled: _vm.disableValidate
            },
            on: { click: _vm.handleValidate }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }